<form [formGroup]="formGroup" class="motricity-index">
  @if (pageTitle) {
    <div class="motricity-index-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="motricity-index-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "section" && isSideSection(element)) {
      <div class="section">
        <b class="section-title">{{ getQuestionTitle(element.title) }}</b>
      </div>
    }
    @if (element.type === "section" && !isSideSection(element)) {
      <div class="motricity-index-group-label">
        <b>{{ getQuestionTitle(element.title) }}</b>
      </div>
    }
    @if (element.type === "radiogroup") {
      <div class="motricity-index-row">
        <div class="motricity-index-q">
          <div class="motricity-index-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="motricity-index-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="motricity-index-group">
          @for (choice of element.choices; track choice.value) {
            <label class="motricity-index-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span class="motricity-index-option-text">{{
                choice.text
              }}</span>
            </label>
          }
        </div>
      </div>
    }
    @if (isScoreElement(element)) {
      <div
        class="motricity-index-score"
        [class.motricity-index-side]="isSideScoreElement(element)"
      >
        <div class="motricity-index-score-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="motricity-index-score-value">
          {{ getScoreDisplay(element.name) }} / {{ maxScore }}
        </div>
      </div>
    }
  }
</form>
